export const buildNumber = '20260225.3';
export const version = 'main';
export const latestCommit = '75d2343b8d78bd5b5677060fa67e6d0d2daa5ed5';
